module.exports = __webpack_public_path__ + "static/uten-silo-75cb6659d1fe782eb26f5352d1f793da.jpg";